<script>
  import utils from './SgsUtils.js';

  export default{
      props: [
        "attr", "fieldValue", "placeholder", "label",
        "showHint", "hintValue", "moduleType"
      ],
      methods: {
        formatField: function(value) {
          return utils.formatField2({
            value: value,
            type: 'boolean',
            misc: {
              yes: this.$t("yes"),
              no: this.$t("no")
            }
          });
        }
      },
      watch: {
        "updateFieldValue": function(val) {
          if (this.attr.eventOnChange) {
            this.$emit('callBusinessRule', this.attr.eventOnChange);
          }
        }
      },
      computed: {
        updateFieldValue: {
          get: function() {
            if (this.fieldValue === undefined || this.fieldValue === null || this.fieldValue === '') {

              if (this.moduleType === 'list' && this.attr && this.attr.inListHideIfNull) {
                return this.fieldValue;
              }

              this.$emit('updateFieldValue', this.attr.columnName, 'YES');
              return 'YES';
            }
            return this.fieldValue;
          },
          set: function(newValue) {
            this.$emit('updateFieldValue', this.attr.columnName, newValue);
          }
        },
        showInList: function() {

          if (this.moduleType === 'list') {

            if (this.updateFieldValue != undefined) {
              return true;
            } else if (this.attr && !this.attr.inListHideIfNull) {
              return true;
            }
          }

          return false;
        }
      }
  }


</script>
<template>
  <div>
    <el-popover
      ref="popover"
      v-show="showHint"
      placement="top-start"
      width="200"
      trigger="hover"
      :content="hintValue">
    </el-popover>

    <el-form-item label="temp" :prop="attr.columnName" v-if="moduleType === 'form'">

      <span slot="label">
        {{label}} <i v-if="showHint && moduleType === 'form'" class="glyphicon glyphicon-question-sign" v-popover:popover />
      </span>

      <div class="block">
        <el-switch
          :on-text="$t('yes')"
          :off-text="$t('no')"
          v-model="updateFieldValue"
          on-color="#13ce66"
          on-value="YES"
          off-value="NO"
          :disabled="attr.disableField"
        />
      </div>
    </el-form-item>

    <div v-if="moduleType === 'show'">
      <label>{{label}}</label>
      <p>
        <el-tag :type="updateFieldValue == 'YES' ? 'success' : 'danger'">
          {{formatField(updateFieldValue)}}
        </el-tag>
      </p>
    </div>

    <span v-if="showInList">
      <el-tag :type="updateFieldValue == 'YES' ? 'success' : 'danger'">
        {{formatField(updateFieldValue)}}
      </el-tag>
    </span>

  </div>
</template>



// WEBPACK FOOTER //
// SgsRenderInputBoolean.vue?e93786cc